import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-teacher-signup',
    template: ''
})
export class TeacherSignupComponent {

  constructor() { }

}
